// Central source of truth for every product image used across the site.
// Update product images here only; ProductData, Home, SEO, and ProductDetail
// all read from this file.

export const PRODUCT_IMAGES = {
  "topical-luteolin-serum": {
    // Used on product cards, homepage, SEO, and anywhere no size is selected.
    heroImage:
      "https://i.etsystatic.com/58761671/r/il/4ec0c6/8306968029/il_fullxfull.8306968029_1pmr.jpg",

    seoImage:
      "https://i.etsystatic.com/58761671/r/il/4ec0c6/8306968029/il_fullxfull.8306968029_1pmr.jpg",

    gallery: [
        "https://i.etsystatic.com/58761671/r/il/4bb589/8256937494/il_fullxfull.8256937494_rwil.jpg",
      "https://i.etsystatic.com/58761671/r/il/310e2d/8304830645/il_fullxfull.8304830645_117f.jpg",
      "https://i.etsystatic.com/58761671/r/il/9ffa75/8256912686/il_fullxfull.8256912686_9lkh.jpg",
      "https://i.etsystatic.com/58761671/r/il/4732c0/8304830211/il_fullxfull.8304830211_a2aq.jpg",
    ],

    // Names must match Prices.js exactly.
    variants: {
      "30ml (1 oz)": {
        heroImage:
          "https://i.etsystatic.com/58761671/r/il/4ec0c6/8306968029/il_fullxfull.8306968029_1pmr.jpg",

        gallery: [
      "https://i.etsystatic.com/58761671/r/il/9ffa75/8256912686/il_fullxfull.8256912686_9lkh.jpg",
      "https://i.etsystatic.com/58761671/r/il/4732c0/8304830211/il_fullxfull.8304830211_a2aq.jpg",
            "https://i.etsystatic.com/58761671/r/il/20061f/8259073616/il_fullxfull.8259073616_amle.jpg",


          // Add more 30ml image URLs here.
        ],
      },

      "50ml": {
        heroImage:
          "https://i.etsystatic.com/58761671/r/il/2794be/8306968033/il_fullxfull.8306968033_roux.jpg",

        gallery: [
          "https://i.etsystatic.com/58761671/r/il/4bb589/8256937494/il_fullxfull.8256937494_rwil.jpg",
          "https://i.etsystatic.com/58761671/r/il/20061f/8259073616/il_fullxfull.8259073616_amle.jpg",

          // Add more 50ml image URLs here.
        ],
      },

      "100ml": {
        heroImage:
          "https://m.media-amazon.com/images/I/61wJrueU9fL._SL1402_.jpg",

        gallery: [
          "https://m.media-amazon.com/images/I/61qtnIzngHL._SL1402_.jpg",
"https://m.media-amazon.com/images/I/51AhQhuSL7L._SL1402_.jpg",
"https://m.media-amazon.com/images/I/61Vk37-SyAL._SL1402_.jpg",
"https://m.media-amazon.com/images/I/71M4Pby9EvL._SL1254_.jpg"
          // Add more 100ml image URLs here.
        ],
      },
    },
  },

  "topical-luteolin-cream": {
    heroImage:
      "https://i.etsystatic.com/58761671/r/il/f6fd98/7387940220/il_fullxfull.7387940220_o0v8.jpg",

    gallery: [
      "https://i.etsystatic.com/58761671/r/il/f6fd98/7387940220/il_fullxfull.7387940220_o0v8.jpg",
      "https://i.etsystatic.com/58761671/r/il/bc37d8/7435870559/il_fullxfull.7435870559_24er.jpg",
      "https://i.etsystatic.com/58761671/r/il/fa50ec/7388017448/il_fullxfull.7388017448_b7hz.jpg",
    ],

    // When needed:
    //
    // variants: {
    //   "50ml": {
    //     heroImage: "...",
    //     gallery: ["...", "..."],
    //   },
    //
    //   "100ml": {
    //     heroImage: "...",
    //     gallery: ["...", "..."],
    //   },
    // },
  },

  "topical-luteolin-lotion": {
    heroImage:
      "https://i.etsystatic.com/58761671/r/il/52c6d8/7859442020/il_300x300.7859442020_990i.jpg",

    gallery: [
      "https://i.etsystatic.com/58761671/r/il/52c6d8/7859442020/il_300x300.7859442020_990i.jpg",
      "https://i.etsystatic.com/58761671/r/il/b7ec67/7671491961/il_300x300.7671491961_q2iz.jpg",
      "https://i.etsystatic.com/58761671/r/il/450f05/7623554398/il_300x300.7623554398_heb0.jpg",
      "https://i.etsystatic.com/58761671/r/il/3a16b5/7907393355/il_300x300.7907393355_f5k0.jpg",
    ],

    // When needed:
    //
    // variants: {
    //   "30ml": {
    //     heroImage: "...",
    //     gallery: ["...", "..."],
    //   },
    //
    //   "50ml": {
    //     heroImage: "...",
    //     gallery: ["...", "..."],
    //   },
    // },
  },
};

function removeDuplicateImages(images) {
  return [...new Set(images.filter(Boolean))];
}

export function getProductImages(productId, variantName) {
  const productImages = PRODUCT_IMAGES[productId];

  if (!productImages) {
    return {
      heroImage: "",
      seoImage: "",
      gallery: [],
    };
  }

  const variantImages = variantName
    ? productImages.variants?.[variantName]
    : null;

  const heroImage =
    variantImages?.heroImage ||
    variantImages?.gallery?.[0] ||
    productImages.heroImage ||
    productImages.gallery?.[0] ||
    "";

  const gallerySource = variantImages?.gallery?.length
    ? variantImages.gallery
    : productImages.gallery || [];

  return {
    heroImage,

    seoImage:
      productImages.seoImage ||
      productImages.heroImage ||
      heroImage,

    gallery: removeDuplicateImages([
      heroImage,
      ...gallerySource,
    ]),
  };
}